import { cloneDeep, curry } from 'lodash';
import { by } from '@qodly/shared';
import { AppState } from '..';

export const listDsNamespaces = curry((tabPath: string, state: AppState) => {
  const namespaces = {
    ...state.sharedDatasources.sources,
  };

  const tabNamespace = (
    state.root.tabs.find(by('path', tabPath))?.content as webforms.Content
  )?.metadata?.datasources;

  if (tabNamespace) namespaces[tabPath] = tabNamespace;

  return cloneDeep(namespaces);
});
